const parametrizationCurveExecutationHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Executado',
        id: 'curva-executado',
        show: true
      },
      {
        name: 'Data',
        id: 'curva-data',
        show: true
      }
    ]
  }
]

export default parametrizationCurveExecutationHeader
